/**
 * Which bill this shop hands over after a sale: the counter receipt (thermal
 * roll) or the A4 tax invoice. Chosen on Settings → Invoice; used by
 * auto-print and to order the print buttons after a sale.
 *
 * Merchant-wide, like the rest of the bill design. A shop that bills
 * businesses (Quick Bill, B2B) typically wants A4; a counter wants the roll.
 */
export const BILL_DOCUMENT_SETTING = 'DEFAULT_BILL_DOCUMENT';

export type BillDocument = 'thermal' | 'a4';

export function resolveBillDocument(raw: string | null | undefined): BillDocument {
  return raw === 'a4' ? 'a4' : 'thermal';
}
